import {contentItemAction} from '../../../actions/contentItemActions';
import {baseAction} from '../../../actions/baseActions';

export interface IntroductionsDismissedReducerState {
  nonSequencedFlowIntroductionDismissed: boolean;
  blindMapIntroductionDismissed: boolean;
}

const emptyState: IntroductionsDismissedReducerState = {
  nonSequencedFlowIntroductionDismissed: false,
  blindMapIntroductionDismissed: false,
};

export function introductionsDismissedReducer(state: IntroductionsDismissedReducerState = emptyState, action: any) {
  switch (action.type) {
    case baseAction.Introduction_Dismiss:
      return {
        ...state,
        nonSequencedFlowIntroductionDismissed: true,
      };
    case contentItemAction.Quiz_BlindMapIntroductionDismissed:
      if (action.payload.dontShowAgain) {
        return {
          ...state,
          blindMapIntroductionDismissed: true,
        };
      }
      return state;
    default:
      return state;
  }
}
